/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import './Loader.scss';

function Loader() {
  return (
      <React.Fragment>
        <div className="loader">
          <div id="loading" />
        </div>
      </React.Fragment>
  );
}

export default Loader;
